// LeftToRightPageWrapper.js
import { motion } from "framer-motion";

const leftToRightVariants = {
  initial: {
    x: "-5vw", // Start off-screen (to the left)
    // opacity: 0.5,
  },
  animate: {
    x: 0, // Move to the center
    // opacity: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 30,
    },
  },
  exit: {
    x: "5vw", // Exit to the right
    // opacity: 0,
    transition: {
      ease: "easeInOut",
      duration: 0.1,
    },
  },
};

const LeftToRightPageWrapper = ({ children }) => {
  return (
    <motion.div
      variants={leftToRightVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="h-full w-full"
    >
      {children}
    </motion.div>
  );
};

export default LeftToRightPageWrapper;
